// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Link from "../Link.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as AugmentName from "common/src/tft-static/AugmentName.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as StatsConfig from "../stats/StatsConfig.bs.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as StatsOverview from "./StatsOverview.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import * as UnitSynergiesTable from "../units/UnitSynergiesTable.bs.js";
import * as TraitSynergiesTable from "../units/TraitSynergiesTable.bs.js";
import IconButton from "@mui/material/IconButton";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";

var cols = [
  StatsTable2.col(true, undefined, (function (param, param$1) {
          return param$1.t("Augment");
        }), undefined, (function (stats, param, param$1) {
          return React.createElement(Link.make, {
                      route: {
                        TAG: /* Stats */0,
                        _0: {
                          TAG: /* Augment */7,
                          id: stats.id,
                          aperture: param$1.aperture
                        }
                      },
                      children: React.createElement("div", {
                            className: "flex items-center"
                          }, React.createElement(AugmentImage.make, {
                                augId: stats.id,
                                size: 27
                              }), React.createElement("div", {
                                className: "pl-1 truncate font-normal font-roboto"
                              }, React.createElement(AugmentName.make, {
                                    id: stats.id
                                  })))
                    });
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return param$1.augmentsT(v.id);
        }), undefined, 174, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Pick rate");
        }), undefined, (function (augStats, globalCount, param) {
          return Global.toFixed(3, Global.f(augStats.count) / Global.f(globalCount) * 8) + "/8";
        }), undefined, (function (v, param, param$1) {
          return T.humanReadableCount(v.count) + " games";
        }), undefined, (function (v, param, param$1) {
          return v.count;
        }), undefined, 95, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Games");
        }), undefined, (function (augStats, param, param$1) {
          return T.humanReadableCount(augStats.count);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.count;
        }), undefined, 80, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Place");
        }), undefined, (function (stats, param, param$1) {
          return Global.toFixed(undefined, stats.place);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.place;
        }), undefined, 70, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Delta");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixedSign(undefined, v.delta2);
        }), undefined, undefined, Caml_option.some(Tooltip.delta), (function (v, param, param$1) {
          return v.delta2;
        }), undefined, 76, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Rel. Delta");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixedSign(undefined, v.delta);
        }), undefined, undefined, Caml_option.some(Tooltip.relDelta), (function (v, param, param$1) {
          return v.delta;
        }), undefined, 90, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Top 4");
        }), undefined, (function (stats, param, param$1) {
          return Global.formatPct3(stats.top4);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.top4;
        }), undefined, 72, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Win");
        }), undefined, (function (stats, param, param$1) {
          return Global.formatPct3(stats.won);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.won;
        }), undefined, 60, undefined, undefined)
];

function AugmentPage$AugmentsList(Props) {
  var augsData = Props.augsData;
  var globalCount = Props.globalCount;
  var keyFn = React.useCallback((function (aug) {
          return aug.id;
        }), []);
  return React.createElement(StatsTable2.make, {
              cols: cols,
              data: augsData,
              context: globalCount,
              keyFn: keyFn,
              stickyColCount: 1,
              defaultSortIdx: 1
            });
}

var make = React.memo(AugmentPage$AugmentsList);

var AugmentsList = {
  cols: cols,
  make: make
};

function AugmentPage$List(Props) {
  var augmentData = Props.augmentData;
  var fullCount = Props.fullCount;
  var globalCount = Props.globalCount;
  Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return /* Units */1;
      });
  var setTab = match[1];
  var tab = match[0];
  var match$1 = React.useState(function () {
        return /* All */0;
      });
  var setStage = match$1[1];
  var stage = match$1[0];
  var aperture = ApertureCtx.useValue(undefined);
  var data;
  switch (stage) {
    case /* All */0 :
        data = augmentData.all;
        break;
    case /* S2 */1 :
        data = Caml_option.nullable_to_opt(augmentData.p1);
        break;
    case /* S3 */2 :
        data = Caml_option.nullable_to_opt(augmentData.p2);
        break;
    case /* S4 */3 :
        data = Caml_option.nullable_to_opt(augmentData.p3);
        break;
    
  }
  var tmp;
  if (data !== undefined) {
    switch (tab) {
      case /* Augments */0 :
          tmp = React.createElement(make, {
                augsData: data.augments,
                globalCount: globalCount
              });
          break;
      case /* Units */1 :
          tmp = React.createElement(UnitSynergiesTable.make, {
                units: data.units,
                totCount: fullCount,
                inContext: false
              });
          break;
      case /* Traits */2 :
          tmp = React.createElement(TraitSynergiesTable.make, {
                traits: data.traits,
                totCount: fullCount,
                inContext: false
              });
          break;
      
    }
  } else {
    tmp = null;
  }
  return React.createElement("div", {
              className: "text-[14px] mh-auto sm:w-[800px]"
            }, React.createElement(ContentSection.make, {
                  className: "py-3 px-0",
                  children: null
                }, React.createElement("div", {
                      className: "flex gap-1 flex-col sm:flex-row sm:items-center justify-between"
                    }, React.createElement("div", {
                          className: "flex items-center"
                        }, React.createElement("div", {
                              className: "pl-2 pr-1 md:pr-2"
                            }, React.createElement(Link.make, {
                                  route: {
                                    TAG: /* Stats */0,
                                    _0: {
                                      TAG: /* Augments */3,
                                      aperture: aperture
                                    }
                                  },
                                  children: React.createElement(IconButton, {
                                        onClick: (function (param) {
                                            
                                          }),
                                        size: "small",
                                        children: React.createElement(ArrowBackIos, {
                                              fontSize: "small"
                                            })
                                      })
                                })), React.createElement(AugmentImage.make, {
                              augId: augmentData.id,
                              size: 30
                            }), React.createElement("h4", {
                              className: "pl-1 text-base"
                            }, React.createElement(AugmentName.make, {
                                  id: augmentData.id
                                }))), React.createElement(Tabs, {
                          children: null,
                          value: stage,
                          onChange: (function (param, s) {
                              return Curry._1(setStage, (function (param) {
                                            return s;
                                          }));
                            })
                        }, React.createElement(Tab, {
                              label: "All stages",
                              value: /* All */0
                            }), React.createElement(Tab, {
                              label: "2-1",
                              value: /* S2 */1,
                              disabled: (augmentData.p1 == null)
                            }), React.createElement(Tab, {
                              label: "3-2",
                              value: /* S3 */2,
                              disabled: (augmentData.p2 == null)
                            }), React.createElement(Tab, {
                              label: "4-2",
                              value: /* S4 */3,
                              disabled: (augmentData.p3 == null)
                            }))), data !== undefined ? React.createElement(StatsOverview.make, {
                        count: data.base.count,
                        place: data.base.place,
                        top4: data.base.top4,
                        won: data.base.won,
                        plDist: data.placeDistribution,
                        regionDist: data.regionStats,
                        fullCount: globalCount
                      }) : null, React.createElement("div", {
                      className: "mt-6"
                    }, React.createElement(Tabs, {
                          children: null,
                          value: tab,
                          onChange: (function (param, t) {
                              return Curry._1(setTab, (function (param) {
                                            return t;
                                          }));
                            })
                        }, React.createElement(Tab, {
                              label: "Units",
                              value: /* Units */1
                            }), React.createElement(Tab, {
                              label: "Traits",
                              value: /* Traits */2
                            }), React.createElement(Tab, {
                              label: "Augments",
                              value: /* Augments */0
                            }))), tmp));
}

var List = {
  make: AugmentPage$List
};

function AugmentPage(Props) {
  var augmentData = Props.augmentData;
  var fullCount = Props.fullCount;
  var globalCount = Props.globalCount;
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(StatsConfig.make, {}), React.createElement(StatsConfig.Context.make, {
                  children: React.createElement(AugmentPage$List, {
                        augmentData: augmentData,
                        fullCount: fullCount,
                        globalCount: globalCount
                      })
                }));
}

var make$1 = AugmentPage;

export {
  AugmentsList ,
  List ,
  make$1 as make,
  
}
/* cols Not a pure module */
